import { type FC } from 'react';
import classNames from 'classnames';

import { FormattedMessage } from 'dibs-react-intl';
import { Link } from 'dibs-elements/exports/Link';

import { trackItemFavoritingSuccessToastCtaClick } from './tracking';

import styles from './styles/PortfolioToast.scss';
import dibsCss from 'dibs-css';

const AddToFolderToastContent: FC<{ portfolioId: string; portfolioName: string }> = ({
    portfolioId,
    portfolioName,
}) => (
    <div
        className={classNames(
            dibsCss.flex,
            dibsCss.justifyBetween,
            dibsCss.itemsCenter,
            dibsCss.gapSmall
        )}
    >
        <span className={dibsCss.sassyFontBodySmallHeavy}>
            <FormattedMessage
                id="itemFavoriting.FolderToastsContent.add"
                defaultMessage="Added To Your{hasPortfolioName, select, true { “{portfolioName}”} other {}} Folder"
                values={{ portfolioName, hasPortfolioName: !!portfolioName }}
            />
        </span>
        {portfolioId && (
            <Link
                href={`/favorites/folders/${portfolioId}/`}
                target="_blank"
                className={classNames(styles.link, dibsCss.sassyFontBodySmallHeavy)}
                onClick={() => trackItemFavoritingSuccessToastCtaClick({ trigger: 'view folder' })}
            >
                <FormattedMessage
                    id="itemFavoriting.FolderToastsContent.add.link"
                    defaultMessage="View Folder"
                />
            </Link>
        )}
    </div>
);

const RemoveFromFolderToastContent: FC<{ portfolioName: string }> = ({ portfolioName }) => (
    <div className={dibsCss.sassyFontBodySmallHeavy}>
        <FormattedMessage
            id="itemFavoriting.FolderToastsContent.remove"
            defaultMessage="Removed From {hasPortfolioName, select, true {“{portfolioName}”} other {folder}}"
            values={{ portfolioName, hasPortfolioName: !!portfolioName }}
        />
    </div>
);

export { AddToFolderToastContent, RemoveFromFolderToastContent };
